import React from 'react';
import Checkbox from '../checkbox';
import EnergyLabel from '../../energy-label';

const EnergyLabelCheckbox = (props) => {
  const options = props.options.map((label) => ({
    ...label,
    Component: <EnergyLabel label={label.name} />,
  }));
  return <Checkbox {...props} options={options} />;
};

export default EnergyLabelCheckbox;
